// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_3l-1";
export var rateTableServiceLevelDropdown = "_3l-3";
export var rateTableTypeDropdown = "_3l-0";
export var rateTableValueModeDropdown = "_3l-2";